import React from 'react';
import '../css/AboutPage.css';

const IconInnovation = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2a7 7 0 0 1 7 7c0 2.38-1.19 4.47-3 5.74V17a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2v-2.26C6.19 13.47 5 11.38 5 9a7 7 0 0 1 7-7z"/>
    <path d="M10 21h4"/>
  </svg>
);

const IconCollaboration = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
);

const IconIntegrity = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    <polyline points="9 12 11 14 15 10"/>
  </svg>
);

const values = [
  {
    Icon: IconInnovation,
    title: 'Innovation',
    description: 'Staying ahead with cutting-edge solutions and forward-thinking approaches that keep you competitive in a fast-moving market.'
  },
  {
    Icon: IconCollaboration,
    title: 'Collaboration',
    description: 'Partnering closely with our clients, understanding your goals deeply to deliver outcomes that truly matter to your business.'
  },
  {
    Icon: IconIntegrity,
    title: 'Integrity',
    description: 'Full transparency at every step — you always know what we\'re building, why, and how it benefits your bottom line.'
  }
];

const AboutPage = () => {
  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="about-hero-content">
          <div className="hero-eyebrow about-eyebrow">
            <span className="hero-eyebrow-line" />
            <span>About Callide</span>
            <span className="hero-eyebrow-line" />
          </div>
          <h1>Driven by Innovation,<br />Grounded in Partnership</h1>
          <p>
            We're a technology consulting firm built to help businesses move faster,
            smarter, and with confidence in every decision.
          </p>
        </div>
      </section>

      <section className="about-mission">
        <div className="about-container-wide">
          <div className="mission-grid">
            <div className="mission-left">
              <span className="about-section-label">Our Mission</span>
              <h2>Helping Businesses Unlock Their Full Potential</h2>
            </div>
            <div className="mission-right">
              <p>
                At Callide LLC, we are passionate about helping businesses unlock their full potential
                through innovative technology solutions. Our mission is to provide expert consulting
                services and create tailored software that aligns with your goals and operations.
              </p>
              <p>
                From discovering existing tools to developing custom platforms, our team specializes
                in crafting solutions that enhance efficiency, improve workflows, and drive business
                success.
              </p>
              <p>
                We believe in building strong partnerships with our clients and delivering results
                that make a tangible impact. Let us help you navigate the ever-evolving technological
                landscape and take your business to the next level.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="about-values-section">
        <div className="about-container-wide">
          <div className="about-section-header">
            <span className="about-section-label">Our Values</span>
            <h2>What We Stand For</h2>
          </div>
          <div className="values-grid">
            {values.map(({ Icon, title, description }) => (
              <div className="value-card" key={title}>
                <div className="value-icon-wrap"><Icon /></div>
                <h3>{title}</h3>
                <p>{description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
